import React from 'react';
import HamburgerMenu from './hamburger-menu.component';
import MegaMenu from './mega-menu.component';

const AimNavbar = () => {
  return (
    <>
      <HamburgerMenu />
      <MegaMenu />
    </>
  );
};

export default AimNavbar;
